import { jsx as c } from "react/jsx-runtime";
import { useMemo as F, useState as V, useEffect as _ } from "react";
import { LinkIcon as I } from "../../icons/link-icon.mjs";
import { twMerge as g } from "tailwind-merge";
import { FormInput as N } from "./form-input.mjs";
import { useTranslation as k } from "../../i18n.mjs";
import { FormSelectInline as z } from "../form-select/form-select-inline.mjs";
import { copyTextToClipboard as A } from "../../utils/copy-to-clipboard.mjs";
const T = (t) => [
  { id: "https://", caption: "https://", customCaption: t("public_pages_purchase.input.url.site") },
  { id: "mailto:", caption: "mailto:", customCaption: t("public_pages_purchase.input.url.mail") },
  { id: "tel:", caption: "tel:", customCaption: t("public_pages_purchase.input.url.tel") }
], U = (t) => {
  var e;
  return ((e = t[0]) == null ? void 0 : e.id) ?? "https://";
}, l = (t, e) => {
  var o;
  return (o = e.find((m) => t.startsWith(m.id))) == null ? void 0 : o.id;
}, b = (t, e) => l(t, e) ?? U(e), p = (t, e) => {
  if (!t) return t;
  const o = l(t, e);
  return o && t.startsWith(o) ? t.slice(o.length) : t;
}, q = ({
  onChange: t,
  value: e = "",
  withCopyButton: o,
  buttonClassName: m,
  linkIconClassName: S,
  schemeOptions: f,
  ...x
}) => {
  var d;
  const { t: a } = k(), i = F(
    () => f ?? T(a).slice(0, 1),
    [f, a]
  ), [s, u] = V(b(e, i));
  _(() => {
    if (!e) return;
    const r = b(e, i);
    r !== s && u(r);
  }, [s, i, e]);
  const y = p(e, i), C = ({ target: { value: r } }) => {
    if (!r) return t("");
    const n = l(r, i);
    if (n) {
      n !== s && u(n);
      const h = p(r, i);
      if (!h) return t("");
      t(n + h);
    } else
      t(s + p(r, i));
  }, w = (r) => {
    if (!r || (u(r), !e)) return;
    const n = p(e, i);
    if (!n) return t("");
    t(r + n);
  };
  return /* @__PURE__ */ c(
    N,
    {
      type: "url",
      addonBefore: i.length > 1 ? /* @__PURE__ */ c(
        z,
        {
          withoutCloseIcon: !0,
          data: i,
          value: s,
          optionsClassName: "min-w-0",
          captionClassName: "no-underline w-max",
          onChange: w
        }
      ) : (d = i[0]) == null ? void 0 : d.caption,
      value: y,
      onChange: C,
      addonAfterClassName: "p-0 sm:p-0 lg:p-0 border-0",
      addonAfter: o && /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          onClick: async (r) => {
            r.preventDefault(), await A(e, a);
          },
          className: g(
            "bg-brand-primary hover:bg-brand-primary-hover focus-ring flex h-full items-center justify-center rounded-r-lg px-2 py-2.5 sm:px-4",
            m
          ),
          children: /* @__PURE__ */ c(
            I,
            {
              className: g(
                "fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]",
                S
              )
            }
          )
        }
      ),
      ...x
    }
  );
};
export {
  q as FormInputUrl,
  T as getUrlSchemeOptions
};
